/**
 * LiveConversationToggle Component
 * Toggle switch for enabling live conversation mode
 */

import React from 'react';
import { FiRadio } from 'react-icons/fi';

interface LiveConversationToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  className?: string;
}

export const LiveConversationToggle: React.FC<LiveConversationToggleProps> = ({
  enabled,
  onChange,
  className = ''
}) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <FiRadio className={enabled ? 'text-green-400' : 'text-gray-500'} size={16} />

      <button
        onClick={() => onChange(!enabled)}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
          enabled ? 'bg-green-500' : 'bg-slate-700'
        }`}
        role="switch"
        aria-checked={enabled}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            enabled ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>

      <span className="text-sm text-gray-300">
        Live Mode
      </span>

      {enabled && (
        <span className="px-2 py-1 bg-green-500/20 text-green-300 text-xs rounded">
          Active
        </span>
      )}
    </div>
  );
};

export default LiveConversationToggle;
